export class PricingModule {

    constructor() {
        if ($("#hospitaltreatmentpricesapi").length > 0) {
            this.init();
        }
	}

    init() {
        this.loadPrices();
        this.ClickEvents();
    }

    addCommas(nStr) {
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    }

    formatToPercentage(amount) {
        return parseFloat(amount * 100).toFixed(1) + "%";
    }

    formatToCurrency(amount) {
        return "£" + this.addCommas(Math.round(amount));
    }

    loadPricingTemplate(element, url, treatmentName, treatmentCode) {

        var that = this;
        let bodyElement = document.getElementsByTagName('body')[0];
        var hospitalName = bodyElement.dataset.hospitalName;
        var paymentButtonText = "Find a payment plan that suits you";
        var showFinanceCalculatorLink = document.getElementById("showFinanceCalculatorLink").value;
        var initialConsultantFeeMissingText = document.getElementById("initialConsultantFeeMissingText").value;
        var overridePriceFeeMissingText = document.getElementById("overridePriceFeeMissingText").value;
        var enquiryFormUrl = document.getElementById("enquiryFormUrl").value;

        var template = ``;
        var innerTemplate = ``;

        template +=
            ``;

        for (var i = 0; i < element.ProceduresApi.length; i++) {

            var item = element.ProceduresApi[i];

            var monthlyPayment, loanAmount, depositTyped, term, representativeAprTyped, totalAmountPayable = 0;
            var procedureName = item.Procedure;
            var procedureCode = item.ProcedureCode;
            var initialConsultantFee = item.InitialConsultation;
            var treatmentPrice = that.formatToCurrency(item.TreatmentPrice);
            var guidePrice = "from " + that.formatToCurrency(item.GuidePrice);


            /* Treatment Loan values */
            if (item.TreatmentLoan != null) {

                if (item.TreatmentLoan.MonthlyPayment == null) {
                    monthlyPayment = "";
                }
                else {
                    monthlyPayment = that.formatToCurrency(item.TreatmentLoan.MonthlyPayment);
                }

                loanAmount = that.formatToCurrency(item.TreatmentLoan.LoanAmount);
                depositTyped = that.formatToCurrency(item.TreatmentLoan.Deposit);
                term = item.TreatmentLoan.Term + " months";
                representativeAprTyped = that.formatToPercentage(item.TreatmentLoan.RepresentativeAPR);
                totalAmountPayable = that.formatToCurrency(item.TreatmentLoan.TotalAmountPayable);
            }
            /* End treatment loan values  */


            var financeCalculatorlink = "/patient-information/finance-calculator/?treatmentAmount=" + item.TreatmentPrice + "&treatmentCode=" + treatmentCode + "&treatmentName=" + treatmentName + "&hospitalName=" + hospitalName;

            if (initialConsultantFee == "0" || initialConsultantFee == "-9999") {
                initialConsultantFee = initialConsultantFeeMissingText;
            }
            else {
                initialConsultantFee = "from " + that.formatToCurrency(initialConsultantFee);
            }

            if (item.RateCardPrice != 0 && item.RateCardPrice != -9999
                && item.ConsultantPrice != 0 && item.ConsultantPrice != -9999
                && item.AnaesthetistPrice != 0 && item.AnaesthetistPrice != -9999) {

                innerTemplate += `
                    <div class="row no-gutters">
                        <div class="col-12">
                            <table class="procedure-price-content-table" cellspacing="0" cellpadding="0" data-procedure-code=${procedureCode}>
                                <thead>
                                    <tr>
                                        <th scope="col" colspan="3" class="procedure-price-content__caption"><span>${procedureName}</span></th>
                                        <th scope="col"><label id="responsive-label2"></label></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colspan="3">Initial consultation</td>
                                        <td class="procedure-price-content__rightcell">${initialConsultantFee}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Treatment</td>
                                        <td class="procedure-price-content__rightcell">${treatmentPrice}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Aftercare</td>
                                        <td class="procedure-price-content__rightcell">Included</td>
                                    </tr>
                                    <tr class="procedure-price-content__total">
                                        <td colspan="3">From price</td>
                                        <td class="procedure-price-content__rightcell">${guidePrice}</td>
                                    </tr>
                                    <tr class="procedure-price-content__total">
                                        <td colspan="3">
                                            <span>Monthly treatment price</span><br>
                                            <span style="font-weight: normal; font-size: 0.7em">(Loan applicable to the treatment cost and excludes the initial consultation)</span>
                                        </td>
                                        <td class="procedure-price-content__rightcell" valign="top">${monthlyPayment}</td>
                                    </tr>
                                </tbody>`;

                if (showFinanceCalculatorLink) {
                    innerTemplate += `<tfoot>
                                    <tr class="procedure-price-content__calculatorlink">
                                        <td colspan="4">
                                            <a class="button button--purple-rounded button--extra-spacing" href="${financeCalculatorlink}">${paymentButtonText}</a>
                                        </td>
                                    </tr>
                                </tfoot>`;                           
                }
                
                innerTemplate += `</table></div></div>`;

                if (loanAmount.length > 0) {
                    innerTemplate += `
                    <div class="row no-gutters">
                        <div class="col-sm-12 col-md-7">
                        <table class="procedure-price-content--plain">
                            <tbody><tr>
                                <td colspan="4">
                                    <strong>Representative example:</strong>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3">Loan amount</td>
                                <td class="procedure-price-content__rightcell">${loanAmount}</td>
                            </tr>
                            <tr>
                                <td colspan="3">Deposit</td>
                                <td class="procedure-price-content__rightcell">${depositTyped}</td>
                            </tr>
                            <tr>
                                <td colspan="3">Loan period</td>
                                <td class="procedure-price-content__rightcell">${term}</td>
                            </tr>
                            <tr>
                                <td colspan="3">Representative APR</td>
                                <td class="procedure-price-content__rightcell">${representativeAprTyped}</td>
                            </tr>
                            <tr>
                                <td colspan="3">Total amount repayable</td>
                                <td class="procedure-price-content__rightcell">${totalAmountPayable}</td>
                            </tr>
                        </tbody></table>
                        </div>
                        <div class="col-sm-12 col-md-5">
                                <a class="button button--mint-rounded button--extra-spacing" href="${url}">View Treatment</a>
                                <a class="button button--green-rounded button--extra-spacing" href="${enquiryFormUrl}" target="_blank">Make an enquiry</a>
                        </div>
                    </div>
                `;
                }
                

            }
        }

        if (innerTemplate == "") {
            innerTemplate += `<p><b>` + overridePriceFeeMissingText + `</b></p>`;

            innerTemplate += `
            <div class="col-sm-12 col-md-5">
                <a class="button button--mint-rounded button--extra-spacing" href="${url}">View Treatment</a>
                <a class="button button--green-rounded button--extra-spacing" href="${enquiryFormUrl}" target="_blank">Make an enquiry</a>
            </div>`;
        }

        template += innerTemplate;

        return template;
    }

    ClickEvents() {
        var root = this;
        $("body").on("click", ".js-getprices", function (e) {
            e.preventDefault()
            var that = this;
            var ison = $(this).hasClass("collapsed");
            
            if (typeof ison !== 'undefined' && ison !== false) {

                var treatmentId = $(this).closest(".spire-accordion").data("id");
                var treatmentUrl = $(this).closest(".spire-accordion").data("treatmenturl");
                var enquiryFormUrl = document.getElementById("enquiryFormUrl").value;
                var treatmentName = $(this).closest(".spire-accordion").data("treatmentname");
                var treatmentCode = $(this).closest(".spire-accordion").data("code");
                var url = apilocation + "pricingapi/GetHospitalTreatmentPrices?id=" + treatmentId;
                var overridePriceFeeMissingText = document.getElementById("overridePriceFeeMissingText").value;

                $(".loading").addClass("show");

                $.ajax({
                    method: "GET",
                    url: url,
                    dataType: "json",
                }).done(function (data) {
                    var template = ``;
                    if (data.ProceduresApi.length > 0) {
                        template = root.loadPricingTemplate(data, treatmentUrl, treatmentName, treatmentCode);
                    }
                    else {

                        template = `

                        <div class="row no-gutters">
                            <div class="col-sm-12 col-md-5">
                                <p><b>${overridePriceFeeMissingText}</b></p>
                            </div>
                        </div>
                        <div class="row no-gutters">
                            <div class="col-sm-12 col-md-5">
                                <a class="button button--mint-rounded button--extra-spacing" href="${treatmentUrl}">View Treatment</a>
                                <a class="button button--green-rounded button--extra-spacing" href="${enquiryFormUrl}" target="_blank">Make an enquiry</a>
                            </div>
                        </div>`;
                    }
                    $(that).closest(".spire-accordion").find(".accordion-body").html(template);

                }).always(function () {
                    $(".loading").removeClass("show");
                });

            }


        });
    }

    loadPrices() {
        let bodyElement = document.getElementsByTagName('body')[0];
        var hospitalid = bodyElement.dataset.id;
        var that = this;
        var endpoint = apilocation + "treatmentapi/GetCurrentHospitalTreatments?hospitalid=" + hospitalid;

        $(".loading").addClass("show");

        $.ajax({
            method: "GET",
            url: endpoint,
            dataType: "json",
        }).done(function (data) {
            var template = ``;
            var accordionId = 0;
            data.treatments.forEach(element => {

                if (element.ShowInPriceList) {
                    accordionId++;

                    template += `
                    <section class="spire-accordion accordion-default" data-id="${element.Id}" data-treatmenturl="${element.Url}" data-treatmentname="${element.TreatmentName}" data-code="${element.Code}">
                        <header class="accordion-heading" role="tab" id="pricingaccordion${accordionId}">
                            <a class="collapsed js-getprices" role="region" data-toggle="collapse" href="#pricingaccordionheader${element.Id}" aria-expanded="true" aria-controls="${element.Id}">
                                <h2 class="accordion-title">
                                    ${element.TreatmentName}
                                </h2>
                                <div class="accordion__icon"></div>
                            </a>
                        </header>
                        <div id="pricingaccordionheader${element.Id}" class="procedure-price-content accordion-collapse collapse" role="tabpanel" aria-labelledby="pricingaccordion${accordionId}">
                            <div class="accordion-body">
                                <p><b>We can't display a fee for this procedure just now. Call us for a quote.</b></p>
                            </div>
                        </div>
                    </section>
                `;
                }

            });

            $(".js-pricing").html(template);
        })
        .always(function () {
            $(".loading").removeClass("show");
        });
    }

}